module.exports = __webpack_public_path__ + "static/april-1-dee9d004f401634b11b5dfd55ed2ba72.png";